const variableTypeMap = {
    STRING: true,
    BOOLEAN: true,
    INTEGER: true,
    STRING_LIST: true,
    INTEGER_LIST: true,
    DELAY_LIST: true,
    JSON: true,
    COLOR: true,
    IMAGE: true,
    FONT: true,
    URL: true,
    CLIENT_KEY_FLOW: true,
    CLIENT_KEY: true,
    EXTOLE_CLIENT_KEY: true,
    REWARD_SUPPLIER_ID: true,
    REWARD_SUPPLIER_ID_LIST: true,
    CLIENT_DOMAIN_ID_LIST: true,
    AUDIENCE_ID: true,
    ENUM: true,
    ENUM_LIST: true,
    PARTNER_ENUM: true,
    PARTNER_ENUM_LIST: true,
    HTML: true,
    ADMIN_ICON: true,
    DELAY: true,
    COMPONENT_ID: true,
};
export const isCampaignComponentVariableResponse = (response) => {
    return Boolean(variableTypeMap[response.type]);
};
export const isBuiltCampaignComponentVariableResponse = (response) => {
    return Boolean(variableTypeMap[response.type]);
};
export const isBuiltCampaignComponentSocketResponse = (response) => {
    return response.type === "MULTI_SOCKET" || response.type === "SOCKET";
};
export const isBuiltComponentPartnerEnumVariableResponse = (response) => {
    return response.type === "PARTNER_ENUM";
};
export const isBuiltComponentPartnerEnumListVariableResponse = (response) => {
    return response.type === "PARTNER_ENUM_LIST";
};
